import script from "./TwoToggleButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoToggleButtonComponent.vue?vue&type=script&setup=true&lang=js"

import "./TwoToggleButtonComponent.vue?vue&type=style&index=0&id=12aa5342&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12aa5342"]])

export default __exports__